module.exports = __webpack_public_path__ + "static/media/Blood.e4631f27.svg";